import React, { Component } from 'react';
import Select from 'react-select';
import { selectors } from '../sagas/product_options';
import { actions } from '../sagas/product_options';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import '../stylesheets/selector.sass';

class ProductOptions extends Component {
  componentWillMount() {
    this.props.requestProducts(this.props.kegNumber, this.props.company_id)
  }

  productOptions = () => {
    let productOptions = []
    this.props.products && this.props.products.forEach(
      product =>
        productOptions.push(
          {
            value: product.id,
            label: product && product.attributes && product.attributes.name
          }
        )
    )
    return productOptions
  }

  handleChange = (event) => {
    this.props.handleProduct(this.props.kegNumber, event, this.props.company_id)
  }

  render () {
    return(
      <div>
        <Select
          className='km-select'
          name="form-field-name"
          style={
            {
              'color': '#333',
              'backgroundColor': '#F9F9F9',
              'outline': 'none',
              'borderColor':'none'
            }
          }
          optionClassName='km-select'
          value={ this.props.selectedProduct }
          onChange={ this.handleChange }
          options={ this.productOptions() }
        />
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch);

const mapStateToProps = (store, ownProps) => ({
  products: selectors.product(store, ownProps.kegNumber)
})

export default (connect(
  mapStateToProps, mapDispatchToProps)(ProductOptions));



// WEBPACK FOOTER //
// ./src/Reservations/ProductOptions.jsx